import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Globals } from '../globals';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { PermisoService } from './permiso.service';
import { BooleanTraductorPipe } from '../pipes/transforms/boolean-traductor.pipe';
import { GeneralService } from './general.service';

@Injectable()
export class OtService {

    constructor(
        private http: HttpInterceptor,
         private globals: Globals,
        private general: GeneralService,
        private permisoService: PermisoService,
        private _booleanTraductorPipe: BooleanTraductorPipe
    ) { }

    guardar(tipoABM: string, model: Object): Observable<any> {
        return this.permisoService.getPermisoAction('OT-' + tipoABM)
            .switchMap((controllerAction) => {
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        {
                            orden_trabajo: model
                        }
                    );
            })
            .map((respuesta: Response) => respuesta.json());
    }

    get(
        paginado: any = {
            page: null,
            pageSize: null
        },
        orden: any = {
            sort: 'fecha_alta',
            order: 'desc'
        },
        filtros: any = {
            generico: ''
        }
    ): Observable<any> {
        return this.permisoService.getPermisoAction('OT-GET')
            .switchMap((controllerAction) => {
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            paginado: paginado,
                            orden: orden,
                            filtros: filtros
                        })
                    );
            })
            .map((respuesta: Response) => respuesta.json());
    }

    getProgramacion(
        paginado: any = {
            page: 0,
            pageSize: 10
        },
        orden: any = {
            sort: 'fecha_alta',
            order: 'asc'
        },
        filtros: any = {
            generico: ''
        }
    ): Observable<any> {
        return this.permisoService.getPermisoAction('PROGRAMACION-GET')
            .switchMap((controllerAction) => {
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            paginado: paginado,
                            orden: orden,
                            filtros: filtros
                        })
                    );
            })
            .map((respuesta: Response) => respuesta.json());
    }

    solicitarAceptacion(model) {
        return this.http
            .post(
                this.general.webserver + 'apiOrdenTrabajo/solicitarAceptacion',
                JSON.stringify(model)
            ).map(
                (respuesta: Response) => respuesta.json());
    }

    cambiarEstado(model) {
        return this.http
            .post(
                this.general.webserver + 'apiOrdenTrabajo/cambiarEstado',
                JSON.stringify(model)
            ).map(
                (respuesta: Response) => respuesta.json());
    }

    asignarStock(model) {
        return this.http
            .post(
                this.general.webserver + 'apiOrdenTrabajo/asignarStock',
                JSON.stringify(model)
            ).map(
                (respuesta: Response) => respuesta.json());
    }

    // toma los datos de la orden como llegan del sv
    // y los formatea para imprimir    
    imprimirOTformato(orden_trabajo) {
        // las características, si no es especial son las del producto y si es especial son las de la orden de trabajo
        orden_trabajo.producto.datos_impresion = [];
        // tipo de producto
        orden_trabajo.producto.datos_impresion.push({
            descripcion: "Tipo",
            a_fabricar: orden_trabajo.producto.tipo.TipoProductoDesc
        });
        if (!!+orden_trabajo.producto.ProductoEspecial) {
            // si es un producto especial
            this.caracteristicasOrdenadas(orden_trabajo.caracteristicas).forEach((x) => {
                orden_trabajo.producto.datos_impresion.push({
                    descripcion: x.caracteristica.CaracProdDesc,
                    a_fabricar: x.valor_opcion ? x.valor_opcion.ValorCaracValor : x.valor
                });
            });
        } else {
            // si no es un producto especial
            this.caracteristicasOrdenadas(orden_trabajo.producto.caracteristicas).forEach(x => {
                orden_trabajo.producto.datos_impresion.push({
                    descripcion: x.descripcion,
                    a_fabricar: x.valor
                });
            });
        }
        orden_trabajo.producto.datos_impresion.push({
            descripcion: "Especificación técnica",
            a_fabricar: orden_trabajo.especificacion_tecnica_archivo_id ? orden_trabajo.especificacion_tecnica_archivo[0].nombre : ''
        });
        orden_trabajo.producto.datos_impresion.push({
            descripcion: "PDTG",
            a_fabricar: orden_trabajo.pdtg_archivo_id ? orden_trabajo.pdtg_archivo[0].nombre : ''
        });
        orden_trabajo.producto.datos_impresion.push({
            descripcion: "Esquema de dimensiones",
            a_fabricar: orden_trabajo.esquema_dimensiones_archivo_id ? orden_trabajo.esquema_dimensiones_archivo[0].nombre : ''
        });
        orden_trabajo.producto.datos_impresion.push({
            descripcion: "CUT",
            a_fabricar: orden_trabajo.CUT
        });
        orden_trabajo.producto.datos_impresion.push({
            descripcion: "Especial",
            a_fabricar: this._booleanTraductorPipe.transform(orden_trabajo.producto.ProductoEspecial)
        });
        orden_trabajo.producto.datos_impresion.push({
            descripcion: "Descripción del producto",
            a_fabricar: orden_trabajo.producto_descripcion
        });
        return orden_trabajo;
    }

    // formato para imprimir los ítems de una asignación
    imprimirAsignacionFormato(item) {
        // las características, si no es especial son las del producto y si es especial son las de la orden de trabajo
        item.producto.datos_impresion = [];
        // tipo de producto
        item.producto.datos_impresion.push({
            descripcion: "Tipo",
            a_fabricar: item.producto.tipo.TipoProductoDesc
        });
        if (!!+item.producto.ProductoEspecial) {
            // si es un producto especial
            this.caracteristicasOrdenadas(item.caracteristicas).forEach((x) => {
                item.producto.datos_impresion.push({
                    descripcion: x.caracteristica.CaracProdDesc,
                    a_fabricar: x.valor_opcion ? x.valor_opcion.ValorCaracValor : x.valor
                });
            });
        } else {
            // si no es un producto especial
            this.caracteristicasOrdenadas(item.producto.caracteristicas).forEach(x => {
                item.producto.datos_impresion.push({
                    descripcion: x.descripcion,
                    a_fabricar: x.valor
                });
            });
        }
        item.producto.datos_impresion.push({
            descripcion: "Especificación técnica",
            a_fabricar: item.orden_venta_detalle.especificacion_tecnica_archivo_id ? item.orden_venta_detalle.especificacion_tecnica_archivo[0].nombre : ''
        });
        item.producto.datos_impresion.push({
            descripcion: "PDTG",
            a_fabricar: item.orden_venta_detalle.pdtg_archivo_id ? item.orden_venta_detalle.pdtg_archivo[0].nombre : ''
        });
        item.producto.datos_impresion.push({
            descripcion: "Esquema de dimensiones",
            a_fabricar: item.orden_venta_detalle.esquema_dimensiones_archivo_id ? item.orden_venta_detalle.esquema_dimensiones_archivo[0].nombre : ''
        });
        item.producto.datos_impresion.push({
            descripcion: "CUT",
            a_fabricar: item.producto.ProductoCUT ? item.producto.ProductoCUT : ''
        });
        item.producto.datos_impresion.push({
            descripcion: "Especial",
            a_fabricar: this._booleanTraductorPipe.transform(item.producto.ProductoEspecial)
        });
        item.producto.datos_impresion.push({
            descripcion: "Descripción del producto",
            a_fabricar: (!!+item.producto.ProductoDescripcionCustom) ? item.producto.ProductoDescripcion : ''
        });
        item.producto.datos_impresion.push({
            descripcion: "Número(s) de máquina",
            a_fabricar: item.orden_venta_detalle.numeros_de_maquina.map(x => x.id).join(" - ")
        });
        return item;
    }

    caracteristicasOrdenadas(caracteristicas) {
        return caracteristicas.sort((a, b) => {
            if (a.caracteristica && typeof a.caracteristica.CaracProdImprOrden != 'undefined') {
                if (a.caracteristica.CaracProdImprOrden > b.caracteristica.CaracProdImprOrden) {
                    return 1;
                }
                if (a.caracteristica.CaracProdImprOrden < b.caracteristica.CaracProdImprOrden) {
                    return -1;
                }
            } else {
                if (a.ordenImpresion > b.ordenImpresion) {
                    return 1;
                }
                if (a.ordenImpresion < b.ordenImpresion) {
                    return -1;
                }
            }
            return 0;
        });
    }
}